import { store } from "../../../../redux/store";
import {
  showLoading,
  hideLoading,
} from "../../../../connected-components/loader/reducer";
import { services } from "../../../../api";
import {
  AddMedicationRequest,
  AddMedicationResponse,
} from "../../../../interfaces/api/medications";

export const addMedication = async (
  data: AddMedicationRequest,
): Promise<AddMedicationResponse | null> => {
  try {
    store.dispatch(showLoading());
    const response = await services.medications.addMedication(data);
    return response;
  } catch (error) {
    console.error("Error adding medication:", error);
    return null;
  } finally {
    store.dispatch(hideLoading());
  }
};
